<template>
  <div class="sf-full-width">
    <div v-if="!hideHeader" class="sf-level sf-font-m sf-pad-b-1">
      {{ I18n.t('communication.remark_form.tags_header') }}
    </div>
    <div class="sf-level">
      <SfMultiselect
        v-model="selectedTagIds"
        data-testid="remark-tags"
        mode="tags"
        :open-direction="openDirection"
        :can-clear="true"
        :clear-on-select="true"
        :hide-selected="true"
        :options="tags"
        :placeholder="
          placeholder || I18n.t('communication.remark_form.tags_placeholder')
        "
        :is-client-meeting-remark="isClientMeetingRemark"
      >
        <template #noresults="{ query }">
          <span v-if="query.length === 0"></span>
        </template>
      </SfMultiselect>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RemarkTag } from '@app/shared/types/sf-data'

import { computed } from 'vue'
import orderBy from 'lodash/orderBy'

import SfMultiselect from '@app/shared/vue/components/sf-multiselect.vue'
import useModel from '@app/shared/vue/composables/use-model'

defineOptions({
  name: 'RemarkTags',
})

interface Props {
  allTags: Record<number, RemarkTag>
  hideHeader?: boolean
  modelValue: number[]
  isClientMeetingRemark?: boolean
  placeholder?: string
  openDirection?: 'top' | 'bottom'
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  openDirection: 'top',
})

const I18n = window.I18n

const emit =
  defineEmits<{
    'update:modelValue': [value: number[]]
  }>()

const selectedTagIds = useModel(props, emit)

const tags = computed(() => {
  const filteredTags = Object.values(props.allTags).filter(
    (tag) => !tag.archived || selectedTagIds.value.includes(tag.id)
  )

  return orderBy(filteredTags, ['talkingPoint', 'name'], ['desc', 'asc']).map(
    (tag) => ({
      value: tag.id,
      label: tag.name,
      archived: tag.archived,
      icon: tag.talkingPoint ? 'fa-solid fa-user-group' : '',
    })
  )
})
</script>
